// --------------------------------------------------------
// QUESTIONNAIRE ANSWERS - QuestionnaireAnswers
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import ArrowRight from "../../../../assets/imgs/arrow-right.svg";
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react'
import { H1, Text } from '../../../../components/UI/generalLayout/Layout.styled'
import { PersonService } from '../../../../core/http/service/PersonService'
import { Detail, Icon } from '../attendanceRecord/AttendanceRecord.styled';
import Colors from "../../../../constants/Colors";
import { Paths } from "../../../../enums/Paths";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// QUESTIONNAIRE ANSWERS INTERFACE
// --------------------------------------------------------

interface IQuestionnaireAnswers {
    pessoa: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const QuestionnaireAnswers = ({ pessoa }: IQuestionnaireAnswers) => {
    // --------------------------------------------------------
    // QUESTIONNAIRE ANSWERS PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [avaliacoes, setAvaliacoes] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const navigate = useNavigate();
    const { currentProfile }: any = useSelector((state: any) => state.login);

    const fetchAvaliacoes = useCallback(async () => {

        try {
            setIsLoading(true)
            const service: PersonService = new PersonService();
            const idOms = '801bea09-a642-4711-a12a-a6d9e7930e28';
            const idHmv = '564d7778-7643-4401-979e-40e49f35c2e3';
            const targetPessoaId = pessoa?.idPessoa || pessoa?.id;
            if (!targetPessoaId) {
                setIsLoading(false);
                return;
            }
            const respostas: any[] = [];
            const resultOMS: any = await service.getAvaliacaoByPessoaId(idOms, targetPessoaId);
            const resultHMV: any = await service.getAvaliacaoByPessoaId(idHmv, targetPessoaId);
            const answersOMS: any[] = resultOMS?.data?.data || [];
            const answersHMV: any[] = resultHMV?.data?.data || [];
            answersOMS.forEach(r => {
                respostas.push({ ...r, questionario: 'oms' })
            })
            answersHMV.forEach(r => {
                respostas.push({ ...r, questionario: 'hmv' })
            })
            const sortFunction = (a: any, b: any) => {
                return moment(a.dataInclusao) > moment(b.dataInclusao) ? -1 : 1;
            }
            setAvaliacoes(respostas.sort(sortFunction))
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }

    }, [pessoa])

    useEffect(() => {
        fetchAvaliacoes();
    }, [])

    const onNavigateAnswer = (id: string, isHMV: boolean) => {
        const path = isHMV ? Paths.HMVQuestionnaire : Paths.OMSQuestionnaire;
        navigate(path, { state: { isView: true, pessoaResposta: pessoa, avaliacaoId: id } })
    }
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <H1>Questionários</H1>
            {isLoading ? (<div style={{ textAlign: 'center', height: 50, marginTop: 100, width: '100%' }}>
                <CircularProgress />
            </div>) : (<>
                {
                    avaliacoes && avaliacoes.length > 0 ?
                        <div style={{ flexDirection: 'row', display: 'flex', gap: 50, marginBottom: 5 }}>
                            <Text bold>Questionário</Text>
                            <Text bold>Data da resposta</Text>
                        </div>
                        :
                        ''
                }
                {
                    avaliacoes && avaliacoes.length > 0 ?
                        avaliacoes.map(aval => {
                            return <div style={{ flexDirection: 'row', display: 'flex', gap: 20, padding: 8, backgroundColor: Colors.GRAY50, marginBottom: 10 }}>
                                <Text bold>{`${aval.questionario === 'oms' ? 'Questionário OMS' : 'Questionário HMV'}`}</Text>
                                <Text bold>{moment(aval.dataInclusao).format('DD/MM/YYYY')}</Text>
                                <div style={{ flexDirection: 'row', display: 'flex', gap: 10, cursor: 'pointer' }} onClick={() => { onNavigateAnswer(aval.id, aval.questionario === 'hmv') }}>
                                    <Detail>VER DETALHES</Detail>
                                    <Icon src={ArrowRight} style={{ marginTop: 18 }} width={10} height={10} />
                                </div>
                            </div>
                        })
                        :
                        ''
                }

            </>)}
            {(avaliacoes && avaliacoes.length === 0 && !isLoading) && (<Text>Nenhum resultado encontrado</Text>)}

        </>
    )
    // --------------------------------------------------------
}

export default QuestionnaireAnswers